import React, { Component } from "react";

import {
  COMPANY_NAME,
  dateString,
  APP_URL,
  AGENT_SERVER_URL,
  APP_LIVE_URL,
  THEME_TEXT_COLOR,
  THEME_COLOR,
  columnsServices,
} from "../../../config/config";
import axios from "axios";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";

import {
  getSubpoena,
  deleteSubpoenaReport,
  subpoenaReportComments,
  approveSubpoenaReport,
  getApprovalLogs,
} from "./../../../config/subpoena_api_calls";

import $ from "jquery";

import DataTable from "../../../components/Tables/DataTableReports";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Link } from "react-router-dom";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";

import dateFormat, { masks } from "dateformat";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import TextField from "../../../components/InputFields/TextField";
import MutextField from "@material-ui/core/TextField";
import * as XLSX from "xlsx";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";
const extendedMoment = extendMoment(moment);

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class SubpoenaReports extends Component {
  constructor() {
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();

    var datestring = new Date().toISOString().slice(0, 10);

    super();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    const today = extendedMoment();
    const monthAgo = moment().subtract(1, "month");
    this.state = {
      tableData: [],
      tableLoader: true,
      //start_date: monthAgo.format("YYYY-MM-DD"),
      //end_date: today.format("YYYY-MM-DD"),
      start_date: "",
      end_date: "",
      selected_order_accountno: null,
      selected_client_accountno: null,
      selected_agent_accountno: null,
      value: moment.range(monthAgo, today),
      commission_title_array: "get_commission_reports",
      commissionReportsArray: [],
      all_active_agents: [],
      all_active_clients: [],
      all_complete_orders: [],
      deposit_main_section: false,
      depositErrorMessage: "",
      depositSuccessMessage: "",
      emailto: "",
      emailcc: "",
      emailbcc: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      emailErrorMessage: "",
      emailErrorMessageTitle: "",
      emailSuccessMessage: "",
      orderno: "",
      form_title: "",
      formDetails: [],
      formGroups: [],
      is_submitted: "",
      payment_method_title: "",
      selected_payment_method: "",
      paymentDetails: [],
      requestDetails: [],
      request_main_section: true,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
      commission_amount: 0,
      payment_amount: (0).toFixed(this.billing_decimalPoint),
      payment_receipt: "",
      payment_notes: "",
      payment_date: new Date(),
      payment_method_pay: "Quickbooks",
      add_picture: "",
      add_picture_name: "",
      fundErrorMessage: "",
      fundSuccessMessage: "",
      add_funds_button: false,
      agent_pending_commision: 0,
      agent_paid_commision: 0,

      successMessage: "",
      errorMessage: "",
      document_file: "",
      csvData: [],

      selectedRows: [],
      bulkAction: "",

      report_id: "",

      subpoena_enabled: "",

      subpoenaComments: [],
      commentsErrorMessage: "",
      comment_main_section: false,

      subpoenaFiles: [],
      filesErrorMessage: "",
      files_main_section: false,

      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approval_main_section: false,
      approvalSuccessMessage: "",
      notifyApproval: false,
      requester_email: "",
      approval_notes: "",
      emailCcs: [],
      inputValueCc: "",
      ccErrorMessage: "",
      approve_client_button: false,
      approval_subpoena_id: "",
      approval_logs_main_section: false,
      approvalLogs: [],
      approvalLogErrorMessageTitle: "",
      approvalLogErrorMessage: "",

      permissionsState: [],
      permission_add: 0,
      permission_edit: 0,
      permission_view: 0,
      permission_delete: 0,

      columnsArray: [
        { name: "title", label: "Title" },
        { name: "subpoena_ren_no", label: "Ref#" },
        {
          name: "client_name",
          label: "Requester Info",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_name(value, tableMeta)}</div>;
            },
            filterOptions: {
              renderValue: (value) => {
                return this.format_name(value, null);
              },
            },
            customFilterListOptions: {
              render: (value) => {
                if (value && typeof value === "string") {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(value, "text/html");

                  // Get the name (first text node before any <br>)
                  const nameNode = doc.body.childNodes[0];
                  const name = nameNode ? nameNode.textContent.trim() : "";

                  // Get the email from any <span>
                  const span = doc.querySelector("span");
                  const email = span ? span.textContent.trim() : "";

                  return `${name} - ${email}`;
                }
                return value;
              },
            },
          },
        },
        {
          name: "created_at",
          label: "Created Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "published_at",
          label: "Published Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "report_status",
          label: "Published Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatusPublished(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "url",
          label: "Report",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setReportLink(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "id",
          label: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setEditLink(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "requesterInfo",
          label: "Requester",
          options: {
            display: false,
          },
        },
      ],
    };
  }

  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    const reportsData = await getSubpoena(
      auth.getAccount(),
      auth.getToken(),
      auth.getUserType(),
      auth.getSubUserAccount(),
      auth.getSubpoenaType(),
    );
    // console.log("getSubpoena: ", reportsData.data);
    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "not_found"
    ) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
      });
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "not_available"
    ) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        subpoena_enabled: "No",
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        commissionReportsArray: reportsData.data.data,
        tableLoader: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
      //window.location.replace("/error");
    }
    $("#viewBtn").show();
    $("#btnloader").hide();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "subpoena",
        "subpoena",
      );
      // console.log("Can Edit Clients:", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_add: canEdit[0].add,
        permission_edit: canEdit[0].edit,
        permission_view: canEdit[0].view,
        permission_delete: canEdit[0].delete,
      });
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  format_name = (value) => {
    return (
      <p
        dangerouslySetInnerHTML={{
          __html: value,
        }}
      ></p>
    );
  };

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "pending") {
      return (
        <div>
          <span className="badge badge-dim badge-primary">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Pending
          </span>
        </div>
      );
    } else if (domain_str === "processing") {
      return (
        <div>
          <span className="badge badge-outline-info">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> In Process
          </span>
        </div>
      );
    } else if (domain_str === "approved") {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done" title="Active"></em> Approved
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-ouline-success">
            {" "}
            <em className="icon ni ni-done "></em> Processed
          </span>
        </div>
      );
    }
  };

  setStatusPublished = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === 0) {
      return (
        <div>
          <span className="badge badge-dim badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Not
            Published
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Published
          </span>
        </div>
      );
    }
  };

  setReportLink = (value, tableMeta) => {
    let domain_str = value;
    let report_id = tableMeta.rowData[8];
    let is_published = tableMeta.rowData[6];
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      if (is_published === 1) {
        return (
          <>
            {this.state.permissionsState &&
            this.state.permissionsState.length > 0 &&
            this.state.permission_view === 1 ? (
              <Tooltip title="View report">
                <a
                  href={`${APP_URL}viewSubpoenaReport/${report_id}`}
                  title="View report"
                  style={{
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  target="_blank"
                >
                  <em
                    className="icon ni ni-reports text-primary"
                    style={{ fontSize: "22px" }}
                  ></em>
                </a>
              </Tooltip>
            ) : (
              "---"
            )}
          </>
        );
      } else {
        return "---";
      }
    } else {
      return "---";
    }
  };

  setEditLink = (value, tableMeta) => {
    let domain_str = value;
    let published_status = tableMeta.rowData[6];
    let status = tableMeta.rowData[5];
    let requester_info = tableMeta.rowData[9];
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      return (
        <>
          {this.state.permissionsState &&
          this.state.permissionsState.length > 0 &&
          (this.state.permission_view === 1 ||
            this.state.permission_edit === 1 ||
            this.state.permission_delete === 1) ? (
            <>
              {this.state.permissionsState &&
              this.state.permissionsState.length > 0 &&
              this.state.permission_edit === 1 ? (
                <Tooltip title="View / Edit Request">
                  <a
                    onClick={() =>
                      this.addMenuHistory("/editSubpoenaReport/" + domain_str)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <em
                      className="icon ni ni-setting text-primary"
                      style={{
                        fontSize: "24px",
                        paddingRight: "5px",
                      }}
                    ></em>
                  </a>
                </Tooltip>
              ) : null}

              {this.state.permissionsState &&
              this.state.permissionsState.length > 0 &&
              this.state.permission_delete === 1 ? (
                <Tooltip title="Delete Request">
                  <a
                    onClick={() => this.deleteReportModal(domain_str)}
                    style={{ cursor: "pointer" }}
                  >
                    <em
                      className="icon ni ni-trash text-danger"
                      style={{
                        fontSize: "24px",
                        paddingLeft: "5px",
                        borderLeft: "1px solid rgb(0 0 0 / 87%)",
                      }}
                    ></em>
                  </a>
                </Tooltip>
              ) : null}
            </>
          ) : (
            "---"
          )}
        </>
      );
    } else {
      return "---";
    }
  };

  commentsModal = async (report_id) => {
    // console.log("deleteReportModal report_id: ", report_id);

    this.setState({
      report_id: report_id,
      comment_main_section: true,
      subpoenaComments: [],
      subpoenaFiles: [],
    });
    // console.log("report_id: ", report_id);
    const reportsData = await subpoenaReportComments(
      auth.getAccount(),
      auth.getToken(),
      report_id,
    );
    // console.log("deleteReport: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        commentsErrorMessage: "Report not found.",
        comment_main_section: false,
      });
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Comments not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        commentsErrorMessage: "Comments not found.",
        comment_main_section: false,
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        commentsErrorMessage: "",
        subpoenaComments: reportsData.data.data,
        subpoenaFiles: reportsData.data.filesList,
        comment_main_section: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        diabled: false,
        commentsErrorMessage: "There is some error while getting the comments.",
        comment_main_section: false,
      });
    }
    window.$("#modalComments").modal("show");
  };

  deleteReportModal = async (report_id) => {
    // console.log("deleteReportModal report_id: ", report_id);
    this.setState({
      request_main_section: false,
      report_id: report_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
    });
    window.$("#modalRequests").modal("show");
  };

  deleteReport = async () => {
    const { report_id } = this.state;
    this.setState({
      diabled: true,
      report_id: report_id,
      requestErrorMessage: "",
      requestErrorMessageTitle: "",
      requestSuccessMessage: "",
    });
    // console.log("report_id: ", report_id);
    const reportsData = await deleteSubpoenaReport(
      auth.getAccount(),
      auth.getToken(),
      report_id,
      auth.getUserType(),
      auth.getSubUserAccount(),
    );
    // console.log("deleteReport: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        requestErrorMessage: "Report not found.",
        requestErrorMessageTitle: "Error",
        requestSuccessMessage: "",
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        requestErrorMessage: "",
        requestErrorMessageTitle: "",
        requestSuccessMessage:
          "Request deleted successfully. Please wait while we refresh the page.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        diabled: false,
        requestErrorMessage: "There is some error while deleting the request.",
        requestErrorMessageTitle: "System Error",
        requestSuccessMessage: "",
      });
    }
  };

  approvalLogsModal = async (report_id, requester_info) => {
    console.log("report_id: ", report_id);
    console.log("requester_info: ", requester_info);
    let requester_email = "";
    let approval_subpoena_id = "";
    if (requester_info && requester_info.length > 0) {
      requester_email = requester_info[0].requester_email;
      approval_subpoena_id = requester_info[0].subpoena_id;
    }
    this.setState({
      approvalLogErrorMessage: "",
      approvalLogErrorMessageTitle: "",
      requester_email: requester_email,
      approval_subpoena_id: approval_subpoena_id,
      approval_logs_main_section: true,
    });
    window.$("#modalApprovalLogs").modal("show");
    const reportsData = await getApprovalLogs(
      auth.getAccount(),
      auth.getToken(),
      approval_subpoena_id,
      requester_email,
    );
    console.log("getApprovalLogs: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        approvalLogErrorMessage: "Report not found.",
        approvalLogErrorMessageTitle: "Error",
        approval_logs_main_section: false,
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        approvalLogs: reportsData.data.data,
        approvalLogErrorMessageTitle: "",
        approvalLogErrorMessage: "",
        approval_logs_main_section: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        approvalLogErrorMessage:
          "There is some error while approving the request.",
        approvalLogErrorMessageTitle: "System Error",
        approval_logs_main_section: false,
      });
    }
  };

  approveReportModal = async (report_id, requester_info) => {
    console.log("report_id: ", report_id);
    console.log("requester_info: ", requester_info);
    let requester_email = "";
    let approval_subpoena_id = "";
    if (requester_info && requester_info.length > 0) {
      requester_email = requester_info[0].requester_email;
      approval_subpoena_id = requester_info[0].subpoena_id;
    }
    this.setState({
      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approvalSuccessMessage: "",
      notifyApproval: false,
      requester_email: requester_email,
      approval_subpoena_id: approval_subpoena_id,
      approval_notes: "",
      emailCcs: [],
      inputValueCc: "",
      ccErrorMessage: "",
      approve_client_button: false,
      approval_main_section: true,
    });
    window.$("#modalApproval").modal("show");
    setTimeout(() => {
      this.setState({
        approval_main_section: false,
      });
    }, 2500);
  };

  approve_subpoena_request = async () => {
    const {
      requester_email,
      approval_subpoena_id,
      emailCcs,
      notifyApproval,
      approval_notes,
    } = this.state;
    this.setState({
      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approvalSuccessMessage: "",
      ccErrorMessage: "",
      approve_client_button: true,
    });
    let notifyApprovals = notifyApproval ? "true" : "false";
    const reportsData = await approveSubpoenaReport(
      auth.getAccount(),
      auth.getToken(),
      approval_subpoena_id,
      requester_email,
      auth.getUserType(),
      auth.getSubUserAccount(),
      notifyApprovals,
      approval_notes,
      JSON.stringify(emailCcs),
    );
    console.log("deleteReport: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        approvalErrorMessage: "Report not found.",
        approvalErrorMessageTitle: "Error",
        approvalSuccessMessage: "",
        approve_client_button: false,
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        approvalErrorMessage: "",
        approvalErrorMessageTitle: "",
        approvalSuccessMessage:
          "Request approved successfully. Please wait while we refresh the page.",
        //approve_client_button: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        diabled: false,
        approvalErrorMessage:
          "There is some error while approving the request.",
        approvalErrorMessageTitle: "System Error",
        approvalSuccessMessage: "",
        approve_client_button: false,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  formatOrderno = (value) => {
    return (
      <a
        href={`${APP_URL}ViewSalesOrder/${value}`}
        className="text-primary"
        target="_blank"
      >
        {value}
      </a>
    );
  };

  formatCommission = (value) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: value,
        }}
      />
    );
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("MMM DD, YYYY"),
      end_date: value.end.format("MMM DD, YYYY"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  regenerate_report = async () => {};

  open_agent_requests = async (value, tableMeta) => {};

  open_deposit_request = async (value, tableMeta) => {};

  modalHideMarketingPDF = (id) => {
    window.$("#" + id).modal("hide");
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    // console.log("handleChange " + name + " " + value);
    this.setState({
      [name]: value,
    });
  };

  handleDateChange = async (date) => {
    await this.handleStatesDynamic(
      "start_date",
      date.toISOString().slice(0, 10),
    );
    // console.log("start_date " + this.state.start_date);
  };

  handleDateChangeEnd = async (date) => {
    await this.handleStatesDynamic("end_date", date.toISOString().slice(0, 10));
    // console.log("end_date " + this.state.end_date);
  };

  handleStatesDynamic = async (start_date, date) => {
    this.setState({
      [start_date]: date,
    });
  };

  handleStates = async (start_date, end_date) => {
    this.setState({
      start_date: start_date,
      end_date: end_date,
    });
  };

  capitalizeFirstLetters = (str) => {
    return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
      return letter.toUpperCase();
    });
  };

  formatAsCurrency = (amount) => {
    //console.log("amount: "+  typeof amount + " - " + amount);
    //console.log("amount: ", typeof amount);
    if (!amount) {
      amount = 0;
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: this.billing_decimalPoint,
      maximumFractionDigits: this.billing_decimalPoint,
    });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation selectedFiles PDF, DOC, DOCX, ZIP, TXT, PNG, JPEG, JPG
    const allowedFileTypes = [".png", ".jpg", ".jpeg", ".pdf"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        uploadErrorMessage:
          "Invalid file type. Please select a valid file format.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // File size validation (e.g., limit to 10MB)
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        uploadErrorMessage:
          "File size exceeds the limit (10MB). Please choose a smaller file.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // Clear any previous errors
    this.setState({
      add_picture: selectedFile,
      uploadErrorMessage: "",
      uploadErrorTitle: "",
      add_picture_name: selectedFile.name,
    });
    //return true;
  };

  handleModalopen = () => {
    window.$("#modalInsertSalesOrder").modal("show");
  };

  handleFileUploadClick = () => {
    document.getElementById("fileInput").click();
  };

  parseExcelData = (data) => {
    try {
      const workbook = XLSX.read(data, { type: "binary" });
      return workbook;
    } catch (error) {
      console.error("Error parsing Excel data:", error);
      return null;
    }
  };

  parseSheetData = (sheet) => {
    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    const headers = data[0]; // Assuming first row contains headers
    const rows = data.slice(1); // Exclude headers
    return rows.map((row) =>
      headers.reduce((acc, header, index) => {
        acc[header] = row[index];
        return acc;
      }, {}),
    );
  };

  downloadPdfRfq = async (d_f_name) => {
    var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    url = APP_LIVE_URL + "files_data/pages/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  handleRowSelection = (rows) => {
    // Update state with the selected rows
    this.setState({ selectedRows: rows });
    // console.log("Selected rows:", rows);
  };

  handleBulkActionChange = (event) => {
    const action = event.target.value;
    this.setState({ bulkAction: action });

    if (action === "approve") {
      this.handleApprove();
    } else if (action === "delete") {
      this.handleDelete();
    }
  };

  handleApprove = () => {
    const { selectedRows } = this.state;
    // console.log("Approve rows:", selectedRows);
    // Add your approve logic here
  };

  handleDelete = () => {
    const { selectedRows } = this.state;
    // console.log("Delete rows:", selectedRows);
    // Add your delete logic here
  };

  handleRemoveTagCc = (index) => {
    this.setState((prevState) => ({
      emailCcs: prevState.emailCcs.filter((_, i) => i !== index),
    }));
  };

  handleChangeTagCc = (event) => {
    const { value } = event.target;
    this.setState({ inputValueCc: value, ccErrorMessage: "" });
  };

  handlePasteCc = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValueCc: pastedText }, this.addCcEmails);
  };

  handleKeyDownCc = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();

      this.addCcEmails();
    }
  };

  addCcEmails = () => {
    const { inputValueCc, emailCcs } = this.state;
    if (!inputValueCc.trim()) return;

    // Split input by commas and remove extra spaces
    let newEmails = inputValueCc
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    // Keep only valid emails
    newEmails = newEmails.filter((email) => this.validateEmails(email));

    if (newEmails.length === 0) {
      this.setState({ ccErrorMessage: "Please enter valid email(s)." });
      return;
    }

    // Remove duplicates (within input + already existing)
    newEmails = [...new Set(newEmails)].filter(
      (email) => !emailCcs.includes(email),
    );

    // Check maximum 5
    if (emailCcs.length + newEmails.length > 5) {
      this.setState({ ccErrorMessage: "Maximum 5 emails allowed!" });
      return;
    }

    this.setState((prevState) => ({
      emailCcs: [...prevState.emailCcs, ...newEmails],
      inputValueCc: "",
      ccErrorMessage: "",
    }));
  };

  validateEmails = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  render() {
    //  let tableTitle = this.props.props.match.params.api_url.replaceAll("_", " ");
    const Theme = {
      palette: {
        primary: {
          contrastText: "#FFFFFF",
          dark: "#000000",
          main: "#000000",
          light: "#000000",
        },
      },
    };
    const { isOpen, value, start_date, end_date, inputValueCc } = this.state;
    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const options = {
      selectableRows: "multiple", // Enable checkboxes for row selection
    };
    const styles = {
      container: {
        width: "100%",
        maxWidth: "100%",
      },
      inputWrapper: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        border: "1px solid #ccc",
        padding: "5px",
        borderRadius: "5px",
        minHeight: "40px",
      },
      tag: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#ebeef2",
        color: "#526484",
        padding: "0 .5rem",
        borderRadius: "3px",
        margin: "0.1875rem 0.1875rem",
        fontSize: "13px",
        lineHeight: "1.5rem",
        fontWeight: "bold",
      },
      removeButton: {
        marginLeft: "8px",
        border: "none",
        background: "none",
        color: "#526484",
        fontWeight: "bold",
        cursor: "pointer",
      },
      input: {
        border: "none",
        outline: "none",
        padding: "5px",
        fontSize: "14px",
        flexGrow: 1,
        minWidth: "50px",
      },
    };
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name="Subpoena Requests"
                        icon="icon ni ni-users"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          {this.state.subpoena_enabled !== "No" ? (
                            <>
                              {this.state.permissionsState &&
                              this.state.permissionsState.length > 0 &&
                              this.state.permission_add === 1 ? (
                                <li className="nk-block-tools-opt">
                                  <a
                                    href="addSubpoenaReport"
                                    className="btn btn-primary"
                                  >
                                    <em className="icon ni ni-file-docs"></em>
                                    &nbsp;Add New Request
                                  </a>
                                </li>
                              ) : null}
                            </>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-4">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      {/* START DATATABLE */}

                      {this.state.subpoena_enabled === "No" ? (
                        <div className="nk-block-content nk-error-ld text-center">
                          <h1 className="nk-error-head">403</h1>
                          <h3 className="nk-error-title">No Access</h3>
                          <p className="nk-error-text">
                            We sincerely apologize for the inconvenience.
                            Subpoena integration is not enabled for your
                            account. Please contact the administrator to enable
                            it.
                          </p>
                          <a href="/" className="btn btn-lg btn-primary mt-2">
                            Back To Home
                          </a>
                        </div>
                      ) : (
                        <>
                          {this.state.tableLoader === true ? (
                            tableLoader()
                          ) : (
                            <DataTable
                              columns={this.state.columnsArray}
                              tableData={this.state.commissionReportsArray}
                              title=""
                              //options={options}
                              //onRowSelection={this.handleRowSelection}
                            />
                          )}
                        </>
                      )}

                      {/* END TABLE */}
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalRequests"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em> Delete
                              Request
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalRequests");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.request_main_section === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-gs">
                              {this.state.requestErrorMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {this.state.requestErrorMessageTitle}
                                        </h4>

                                        <p>{this.state.requestErrorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.requestSuccessMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>

                                        <p>
                                          {this.state.requestSuccessMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="col-sm-12">
                                <div className="card card-bordered mt-1">
                                  <div className="card-inner-group">
                                    <div className="card-inner">
                                      <div
                                        className="sp-plan-desc sp-plan-desc-mb"
                                        id="paymentMethodDetails"
                                      >
                                        <div id="no-more-tables-new">
                                          Are you sure you want to permanently
                                          delete this request?
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div className="d-flex justify-content-end">
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.modalHideMarketingPDF(
                                        "modalRequests",
                                      );
                                    }}
                                    className="btn btn-light mr-2"
                                  >
                                    Cancel
                                  </a>
                                  <button
                                    type="button"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.deleteReport()}
                                    className="btn btn-primary"
                                    disabled={this.state.diabled}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}
                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalComments"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em> Result
                              Files / Comments
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalComments");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.comment_main_section === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-gs">
                              {this.state.commentsErrorMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>

                                        <p>{this.state.commentsErrorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              <div className="col-sm-12">
                                <ul className="nav nav-tabs">
                                  <li className="nav-item">
                                    <a
                                      className="nav-link active"
                                      data-toggle="tab"
                                      href="#tabItem5"
                                    >
                                      <em className="icon ni ni-user"></em>
                                      <span>Result Files</span>
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className="nav-link"
                                      data-toggle="tab"
                                      href="#tabItem6"
                                    >
                                      <em className="icon ni ni-lock-alt"></em>
                                      <span>Comments</span>
                                    </a>
                                  </li>
                                </ul>
                                <div className="tab-content">
                                  <div className="tab-pane active" id="tabItem5">
                                    {this.state.subpoenaFiles &&
                                    this.state.subpoenaFiles.length > 0 ? (
                                      <div className="col-sm-12">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th scope="col">File</th>
                                              <th scope="col">View</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.subpoenaFiles.map(
                                              (comment, index) => (
                                                <tr key={`idsx${index}`}>
                                                  <th scope="row">
                                                    {comment.added_file}
                                                  </th>
                                                  <td>
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadPdfRfq(
                                                          comment.added_file,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-primary">
                                                        Download
                                                      </span>
                                                    </a>
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h6>No Files</h6>
                                          <p>
                                            There are no files at the
                                            moment.{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="tab-pane" id="tabItem6">
                                    {this.state.subpoenaComments &&
                                    this.state.subpoenaComments.length > 0 ? (
                                      <div className="col-sm-12">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th scope="col">Date</th>
                                              <th scope="col">Comment</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.subpoenaComments.map(
                                              (comment, index) => (
                                                <tr key={`idx${index}`}>
                                                  <th scope="row">
                                                    {this.format_date(
                                                      comment.dateAdded,
                                                    )}
                                                  </th>
                                                  <td>{comment.comments}</td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h6>No Comments</h6>
                                          <p>
                                            There are no comments at the
                                            moment.{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}
                  {/* Approval Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalApproval"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              Approve Request and Send Notifications
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalApproval");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.approval_main_section === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-gs">
                              {this.state.approvalErrorMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {this.state.approvalErrorMessageTitle}
                                        </h4>

                                        <p>{this.state.approvalErrorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.approvalSuccessMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>

                                        <p>
                                          {this.state.approvalSuccessMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              <div className="col-sm-12">
                                <div className="nk-modal-text">
                                  <div className="caption-text">
                                    Do you want to approve this report? Once
                                    approved, if the 'Send notifications' option
                                    is selected, it will be sent to the
                                    requester and also to the CC email
                                    addresses.
                                  </div>
                                </div>
                                <div className="row g-4">
                                  <div
                                    className="col-lg-12"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <h6
                                      style={{
                                        margin: 0,
                                        marginRight: "10px",
                                      }}
                                    >
                                      <Tooltip
                                        title="Essential approver notes about the approval."
                                        placement="right"
                                      >
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            color: "#6576ff",
                                          }}
                                        ></em>
                                      </Tooltip>{" "}
                                      Notes <sup>*</sup>
                                    </h6>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <textarea
                                        className="form-control"
                                        id="approval_notes"
                                        name="approval_notes"
                                        maxLength="500"
                                        value={this.state.approval_notes}
                                        onChange={this.handleChange}
                                      ></textarea>
                                      <small>
                                        Maximum 500 characters are allowed.
                                      </small>
                                    </div>
                                  </div>
                                  <div
                                    className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                    style={{ padding: 0, marginLeft: "3rem" }}
                                  >
                                    <div className="form-group">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck2"
                                        onChange={() => {
                                          const isChecked =
                                            !this.state.notifyApproval;
                                          this.setState({
                                            notifyApproval: isChecked,
                                          });
                                          // console.log("Notify Checkbox Checked:", isChecked);
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        for="customCheck2"
                                      >
                                        Send notifications to the requester and
                                        copy the CC email addresses
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-sm-12">
                                    <div className="form-group mt-2">
                                      <label className="form-label" for="emailto">
                                        Requester Email <sup></sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="requester_email"
                                          name="requester_email"
                                          value={this.state.requester_email}
                                          onChange={this.handleChange}
                                          placeholder="Enter email address"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <label className="form-label" for="title">
                                        CC Email(s) <sup></sup>
                                      </label>

                                      <div className="form-control-wrap">
                                        <small>
                                          These email addresses will also
                                          receive the subpoena details if the
                                          'Send notifications' checkbox above is
                                          selected.
                                        </small>
                                        <div style={styles.container}>
                                          <div style={styles.inputWrapper}>
                                            {this.state.emailCcs.map(
                                              (tag, index) => (
                                                <span
                                                  key={index}
                                                  style={styles.tag}
                                                >
                                                  {tag}
                                                  <button
                                                    type="button"
                                                    style={styles.removeButton}
                                                    onClick={() =>
                                                      this.handleRemoveTagCc(
                                                        index,
                                                      )
                                                    }
                                                  >
                                                    &times;
                                                  </button>
                                                </span>
                                              ),
                                            )}
                                            <input
                                              type="text"
                                              value={inputValueCc}
                                              onChange={this.handleChangeTagCc}
                                              onKeyDown={this.handleKeyDownCc}
                                              onPaste={this.handlePasteCc}
                                              placeholder="Enter or paste valid email addresses..."
                                              style={styles.input}
                                            autoComplete="new-password" />
                                          </div>
                                        </div>
                                        <small>
                                          1. Only valid email addresses are
                                          allowed.
                                          <br />
                                          2. Maximum 5 emails allowed.
                                          <br />
                                          3. No duplicates allowed (even across
                                          pasted and existing values).
                                          <br />
                                          4. Press "Enter" or "," to add an
                                          email manually.
                                          <br />
                                          6. Click "X" to remove an email.
                                          <br />
                                          7. Paste comma-separated emails (with
                                          or without spaces) (e.g.,
                                          abc@example.com,john@example.com)
                                        </small>
                                      </div>
                                    </div>
                                    {this.state.ccErrorMessage !== "" ? (
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>CC Email Error</h4>
                                            <p>{this.state.ccErrorMessage}</p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="nk-modal-action border-top pt-5">
                                  <div className="d-flex justify-content-end">
                                    {this.state.approve_client_button ? (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        type="button"
                                        disabled
                                      >
                                        <span
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span> Processing... </span>
                                      </button>
                                    ) : (
                                      <>
                                        <a
                                          style={{
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                          className="btn btn-lg btn-dim btn-outline-light"
                                          onClick={() => {
                                            this.modalHideMarketingPDF(
                                              "modalApproval",
                                            );
                                          }}
                                        >
                                          <em className="icon ni ni-cross-round"></em>{" "}
                                          <span>Cancel</span>
                                        </a>
                                        {"  "}
                                        <a
                                          style={{ cursor: "pointer" }}
                                          className="btn btn-lg btn-mw btn-primary"
                                          onClick={() => {
                                            this.approve_subpoena_request();
                                          }}
                                          disabled={
                                            this.state.disabled ||
                                            this.state.isProcessing
                                          } // disable button when processing
                                        >
                                          <em className="icon ni ni-done"></em>{" "}
                                          <span>Approve</span>
                                        </a>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Approval MODAL End */}
                  {/* Approval Logs MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalApprovalLogs"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              Approval Logs
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF("modalApprovalLogs");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.approval_logs_main_section === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-gs">
                              {this.state.approvalLogErrorMessage !== "" ? (
                                <div className="col-sm-12">
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {
                                            this.state
                                              .approvalLogErrorMessageTitle
                                          }
                                        </h4>

                                        <p>
                                          {this.state.approvalLogErrorMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              <div className="col-sm-12">
                                <div className="tab-pane" id="tabItem6">
                                  {this.state.approvalLogs &&
                                  this.state.approvalLogs.length > 0 ? (
                                    <div className="col-sm-12">
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th scope="col">Aprroved Date</th>
                                            <th scope="col">Requester Email</th>
                                            <th scope="col">CC Emails</th>
                                            <th scope="col">
                                              Notification Sent
                                            </th>
                                            <th scope="col">Comment</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.approvalLogs.map(
                                            (comment, index) => (
                                              <tr key={`idx${index}`}>
                                                <th scope="row">
                                                  {this.format_date(
                                                    comment.approvelDate,
                                                  )}
                                                </th>
                                                <td>
                                                  {comment.requester_email}
                                                </td>
                                                <td>
                                                  {comment.email_cc &&
                                                  comment.email_cc !== ""
                                                    ? JSON.parse(
                                                        comment.email_cc,
                                                      ).join(", ")
                                                    : ""}
                                                </td>
                                                <td>
                                                  {comment.notify_enabled ===
                                                  "true" ? (
                                                    <span className="text-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="text-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                                <td>
                                                  {comment.approval_notes}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : (
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h6>No Approval Logs</h6>
                                        <p>
                                          There are no approval logs at the
                                          moment.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Approval Logs MODAL End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubpoenaReports);
